// src/pages/DownloadPopup.tsx
import { Button, Box, Typography } from "@mui/material";
import { saveAs } from "file-saver";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useReturnRequestApi } from "../../hooks/useReturnRequestApi.ts";
import { defaultReturnRequest, ReturnRequest } from "./types.ts";

export default function DownloadPopupOnlyPDF() {
  const [search] = useSearchParams();
  const key = search.get('key')!;
  const [downloading, setDownloading] = useState(false);
  const [formData, setFormData] = useState<ReturnRequest>(defaultReturnRequest);
  const { downloadPdf } = useReturnRequestApi();

    useEffect(() => {
        console.log("[popup] send POPUP_READY");
        window.opener?.postMessage({ type: "POPUP_READY" }, "*");
    }, []);

  /* 1) 부모에게 "POPUP_READY" 알림 */
  useEffect(() => {
    const onMsg = (e: MessageEvent) => {
      if (e.source !== window.opener) return;
      console.log("[popup] received", e.data);
      setFormData(e.data.payload);
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);


  const downloadPdfFunction = async () => {
    if (!formData) return;
    setDownloading(true);
    try { 
      await downloadPdf(formData)
      
      localStorage.removeItem(key)
      // setTimeout(() => window.close(), 1000);   // 팝업 자동 종료
    } catch (e) {
      alert("다운로드 실패: " + (e as Error).message);
      setDownloading(false);
    }
  };
  
  return (
    <Box
      sx={{height:"100vh",display:"flex",flexDirection:"column",
           alignItems:"center",justifyContent:"center",gap:2}}
    >
      <Typography variant="h6">
        회수요청서 다운로드
      </Typography>

       <Button
        variant="contained"
        size="large"
        disabled={downloading || !formData}
        onClick={downloadPdfFunction}
      >
        {downloading ? "다운로드 중..." : "PDF 다운로드"}
      </Button>
    </Box>
  );
}

